<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"PEOPLE"'></app-infrastructure-header>

<!-- Main Assets Component Body -->
<app-main-people-component [displayHeader]="false"></app-main-people-component>
